export default "__VITE_ASSET__40c486e1__"